export default "__VITE_ASSET__B66ktb1w__"